import { WebStoreApiConfiguration } from '../models';

let WEBSTORE_API_BASE_API_CONFIG: WebStoreApiConfiguration = {
  baseUrl: '',
  marketLocale: '',
  scopes: [],
  storage: localStorage,
};

export const getWebStoreApiConfig = (): WebStoreApiConfiguration => {
  return WEBSTORE_API_BASE_API_CONFIG;
};

export const setWebStoreApiConfig = (config: WebStoreApiConfiguration) => {
  WEBSTORE_API_BASE_API_CONFIG = { ...config };
};
